const toggle = () => {
    const button = document.querySelector('.shop-categories-show-all');
    const elements = document.querySelectorAll('.shop-categories-slider .shop-categories-item');
    if (!button || !elements) {
        return;
    }

    button.addEventListener('click', () => {
        button.style.display = 'none';
        elements.forEach((e) => {
            e.style.display = 'block';
        });
    });
};

export default () => {
    toggle();
}
